export default __webpack_public_path__ + "static/media/Mec Logo.ff60d376.png";